import { makeAutoObservable } from 'mobx';
import { validateScalingIn } from './validateScalingIn';

export class ScalingInData {
  quantityBasisValues = [];
  breakPrices = [];

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.quantityBasisValues = [];
    this.breakPrices = [];
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const data = {
      quantityBasisValues: this.quantityBasisValues,
      breakPrices: this.breakPrices,
    };
    const result = validateScalingIn(data);
    return result;
  };

  returnJson = () => {
    return {
      quantityBasisValues: this.quantityBasisValues,
      breakPrices: this.breakPrices,
    };
  };

  //specific methods
  addQuantityBasisValue = (number) => {
    this.quantityBasisValues.push(number);
  };
  removeQuantityBasisValue = (index) => {
    const newArr = this.quantityBasisValues.filter((_, i) => i !== index);
    this.quantityBasisValues = newArr;
  };
  clearQuantityBasisValues = () => {
    this.quantityBasisValues = [];
  };
  addBreakPrice = (number) => {
    this.breakPrices.push(number);
  };
  removeBreakPrice = (index) => {
    const newArr = this.breakPrices.filter((_, i) => i !== index);
    this.breakPrices = newArr;
  };
  clearBreakPrices = () => {
    this.breakPrices = [];
  };
}
